export const TypeFormQuestions = {
  Role: 'question-role',
  Industry: 'question-industry',
  Reason: 'question-reason',
  WebsiteNumber: 'question-website-number',
  CreationOption: 'question-creation-option',
  WhoBuilds: 'question-who-builds',
  BuildingFor: 'question-building-for',
  FirstChosenOption: 'question-first-chosen-option',
  LastChosenOption: 'question-last-chosen-option',
  Source: 'question-source',
  Action: 'question-action',
};
export const TypeFormAnswers = {
  AGENCY: 'EcXDdaMlCp6Y',
  FREELANCE: '47FLKgDD5RFJ',
  SMB: 'eLLnqwOWEyzs',
  ENTREPRENEUR: 'YHQEEYZ2KL9U',
  E_COMMERCE: 'eLLnqwOWEyzs',
  BLOGGER: 'YHQEEYZ2KL9U',
  OTHER_BUSINESS: 'HcsSMbMIMP04',

  EXPERTS_AGENCY: '96xGIciBFemu',
  EXPERTS_FREELANCER: 'PnbZa0deeBEi',

  WEB_DEV_AGENCY: 'iLw2GPgfjFSB',
  MARKETING_AGENCY: 'GbRimRPp6W1Z',
  DESIGN_AGENCY: 'xtosGP210ouU',
  OTHER_AGENCY: '112pzzKxOUOo',

  WEB_DEV_FREELANCE: 'wTrdDoiT29uP',
  MARKETING_FREELANCE: 'hn0k42wJmAp8',
  DESIGN_FREELANCE: 'f3uAkXsSxhPl',
  OTHER_FREELANCE: 'j79CJqjVuint',

  FROM_1_TO_3: 'EQ6sqoPuMvGg',
  FROM_4_TO_10: '809P1EgjQ9Iy',
  FROM_11_TO_20: 'ESLrdLF86hg4',
  FROM_21_TO_50: '5pcf3Cn4wjSk',
  FROM_51__100: 'YnlVFDWTJsiE',
  FROM_100_AND_MORE: '58H8pCsVjTUX',

  GET_90_PLUS: 'zS9BHlb9PmME',
  GET_SECURE_RELIABLE_HOSTING: 'Jwl4iT7KfGvj',
  REDUCE_HOSTING_COSTS: 'MrtnbhzzcnBb',
  OTHER_WHY: 'zCMNaMvRbfAJ',

  OPTIMIZE_MY_WEBSITE: 'czlbVTBXh8qR',
  BUILD_NEW_WEBSITE: '3ZvMwFp74s29',
  DESIGNER_MADE_TEMPLATE: 'ELHiD9Z5x2fU',
  BUILD_WITH_TENWEB_IO: 'SQtLL6qMClw5',
  USING_YOUR_PLUGINS: 'SQtLL6qMClw5',

  BUILD_MYSELF: 'lrdFzxEfJm2C',
  BUILD_MY_CLIENT: 'fY7rDU2fCnZz',

  YOUTUBE: 'kkODsCGmFkoQ',
  GOOGLE_SEARCH: 'EThU0oUttO15',
  ADVERTISING: '1dv4LL9P1PLs',
  BY_FRIEND: 'PJuPbicvpbqU',
};

export class SignUpFor {
  public Industry: { answer: string, id: string };
  public Reason: { answer: string, id: string };
  public Role: { answer: string, id: string };
  public WebsiteNumber: { answer: string, id: string };
  public CreationOption: { answer: string, id: string };
  public WhoBuilds: { answer: string, id: string };
  public BuildingFor: { answer: string, id: string };
  public FirstChosenOption: { answer: string, id: string };
  public LastChosenOption: { answer: string, id: string };
  public Action: { answer: string, id: string };
  public Source: { answer: string, id: string };
}


